import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProjectCard from './ProjectCard';
import SectionHeader from './SectionHeader';
import { getFeaturedProjects } from '../services/projectService';

const FeaturedProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getFeaturedProjects(3).then(setProjects);
  }, []);

  return (
    <section className="relative py-28 lg:py-32 bg-cream-100">
      {/* Dot pattern overlay */}
      <div className="absolute inset-0 dot-pattern opacity-[0.03]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-20">
          <SectionHeader
            label="Our Portfolio"
            title="Featured Projects"
            subtitle="Discover our finest developments that redefine luxury living in Burhanpur."
          />
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-16">
          {projects.map((project, index) => (
            <ProjectCard
              key={project.id || project._id}
              project={project}
              index={index}
            />
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link to="/projects" className="btn-premium">
            <span>View All Projects</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
